import Colophon from '@/components/base/Colophon'
import Legals from '@/components/base/Legals'
import Socials from '@/components/base/Socials'
import SVGIcon from '@/components/base/SVGIcon'

import { cn } from '@/lib/utils'

const FooterSection = () => {
  return (
    <footer
      className={cn([
        'relative mt-spacing-lg flex flex-col items-center space-y-spacing-xs py-spacing-sm',
        'lg:hidden'
      ])}
    >
      <button className="flex">
        <SVGIcon
          symbol="rossinavi-logo"
          className="h-[1.6rem] w-[8.3rem] fill-text-heading-light"
        />
      </button>

      <div className="flex flex-col items-center space-y-spacing-xs whitespace-nowrap">
        <Legals />

        <Colophon />
      </div>

      <Socials />
    </footer>
  )
}

export default FooterSection
